import * as React from 'react';
import './Button.scss';

export enum ButtonColor {
    Orange = 'orange',
    White = 'white',
}

export enum IButtonType {
    button = 'button',
    submit = 'submit',
}

export interface IProps {
    title: string;
    color?: ButtonColor;
    fullWidth?: boolean;
    fat?: boolean;
    type?: IButtonType;
}

export interface IFunctions {
    onClick?: () => void;
}

export type IAllProps = IProps & IFunctions;

export const Button: React.SFC<IAllProps> = ({
    title,
    onClick,
    color,
    fullWidth,
    fat,
    type,
}) =>
    <button
        type={type || IButtonType.button}
        className={`
            Button-wrap
            button-color-${color || ButtonColor.Orange}
            ${fullWidth && 'button-full-width'}
            ${fat && 'button-fat'}
        `}
        onClick={e => {
            if (onClick) {
                e.preventDefault();
                onClick();
            }
        }}>
        {title}
    </button>;

export default Button;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/button/Button.tsx